import {useQuery} from 'react-query'
//  import {AreawiseEditModalForm} from './AreawiseEditModalForm'
//  import {isNotEmpty, QUERIES} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import { QUERIES, isNotEmpty } from '../../../../../../_metronic/helpers'
  import {getAreawiseById} from '../core/_requests'
import { AreawiseEditModalForm } from './AreawiseEditModalForm'
// import { QUERIES, isNotEmpty } from '../../../../../_metronic/helpers'

const AreawiseEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const dataresponse = {name:"demo"}
  const {
    isLoading,
    data: areawise,
    error,
  } = useQuery(
    `${QUERIES.AREAWISES_LIST}-areawise-${itemIdForUpdate}`,
    () => {
      return getAreawiseById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
       // setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <AreawiseEditModalForm isAreawiseLoading={false} areawise={{id: undefined}} />
  }

  if (itemIdForUpdate) {
    return <AreawiseEditModalForm isAreawiseLoading={false} areawise={dataresponse} />
  }

  return null
}

export {AreawiseEditModalFormWrapper}
